module.exports = __webpack_public_path__ + "static/epdm-2-0a7fd7416ed74415aff6df7f57773d69.jpg";